import {EWedletEditMode, EWedletEditModeLabel, IElementWedlet, IVirtualisableWedlet, IWedlet, WEDLET} from "back/edit/wed/wedlets/wedlet";
import {AgEltBoxSelection, IEltBoxSelection} from "back/edit/wed/features/boxSel";
import {IBoxInputDiffMaker, insertAnnot, removeAnnot} from "back/edit/wed/wedlets/box/boxTags";
import {IJmlSubSet} from "lib/commons/xml/jml";
import {DOMSH} from "lib/commons/xml/domsh";
import {REG} from "lib/commons/registry";
import {Compartment, EditorState, Extension, StateEffect, StateField, Transaction} from 'res/codemirror/state';
import {Decoration, DecorationSet, EditorView, highlightSpecialChars, keymap} from 'res/codemirror/view';
import {indentOnInput, Language, LanguageDescription, LanguageSupport} from 'res/codemirror/language';
import {StreamLanguage, StreamParser} from "res/codemirror/stream-parser";
import {RangeSet, RangeSetBuilder, RangeValue} from 'res/codemirror/rangeset';
import {foldGutter, foldKeymap} from 'res/codemirror/fold';
import {Text} from 'res/codemirror/text';
import {lineNumbers} from 'res/codemirror/gutter';
import {defaultKeymap, defaultTabBinding} from 'res/codemirror/commands';
import {bracketMatching} from 'res/codemirror/matchbrackets';
import {closeBrackets, closeBracketsKeymap} from 'res/codemirror/closebrackets';
import {autocompletion, completionKeymap} from 'res/codemirror/autocomplete';
import {commentKeymap} from 'res/codemirror/comment';
import {defaultHighlightStyle} from 'res/codemirror/highlight';
import {oneDark} from 'res/codemirror/theme-one-dark';
import {AgEltBoxInsertDrawerBox} from "back/edit/wed/features/insMgr";
import {isXmlMsg, IXmlMsg, XmlBatch, XmlInsertMsg} from "lib/edit/ot/xmlHouse";
import {IXAddrRangeSel, XA} from "lib/commons/xml/xAddr";
import {ACTION} from "lib/commons/actions";
//import { highlightSelectionMatches, searchKeymap } from 'res/codemirror/search';
//import { rectangularSelection } from 'res/codemirror/rectangular-selection';
import {javascript} from "res/codemirror/lang-javascript";
import {ISkAnnot, ISkAnnotDrawer, ISkAnnotFocuser, isSkTextAnnot} from "lib/edit/schema/schemaAnnots";
import {SkSearchTextAnnot} from "lib/edit/schema/schemaSearch";
import {ThemeAction, UiThemeDeskFeat} from "back/core/plugins/optionsPlg";
import {WedMgr} from "back/edit/wed/wedEditor";
import {DOM} from "lib/commons/xml/dom";
import {IDiffAnnotValue} from "lib/edit/schema/diff";
import {WedDiffValue} from "back/edit/wed/wedlets/diff/diffTags";
import {Msg} from "lib/edit/ot/urban";
import {WED} from "back/edit/wed/wedCore";
import {BoxModel, BoxWedlet} from "back/edit/wed/wedlets/box/box";
import {IWedletSingleElt} from "back/edit/wed/wedlets/wedletSingleElt";

/** Wedlet pour le bind texte encapsulant codeMirror. */
class BoxModelCm extends BoxModel {
	findBoxInputCode(wedlet: BoxWedlet): BoxInputCode | null {
		return DOMSH.findFlatNext(wedlet.element, wedlet.element, (n): n is BoxInputCode => n instanceof BoxInputCode)
	}
}

WED.registerWedletModel("BoxCm", BoxModelCm);

export class InputCode extends HTMLElement {
}

export class BoxInputCode extends InputCode implements IElementWedlet, IEltBoxSelection, ISkAnnotDrawer, ISkAnnotFocuser, IBoxInputDiffMaker {
	wedlet: IWedlet;

	focusableElement: HTMLElement;

	cmView: EditorView;

	langTypeProvider: ILangTypeProvider;
	langTypeDef: string;
	langType: Extension | Promise<Extension> | null;

	diffLangTypeDef: string;
	diffLangType: Extension | Promise<Extension> | null;

	batching = false;

	get selMode(): 'box' | 'input' | 'caret' {return 'caret'}

	configWedletElt(tpl: Element, wedlet: IWedletSingleElt): void {
		this.wedlet = wedlet;
		const wedMgr = wedlet.wedMgr;
		wedMgr.listeners.on("getCurrentSel", getCurrentSel, -10);
		wedMgr.listeners.on("hookMsgForNextSel", hookMsgForNextSel);
		wedlet.element?.setDelegatedHost(this);//Pour affecter correctement WedMgr.lastFocus sur les events 'focus' même si le box-ctn-input a déjà le focus.
		const sr = this.attachShadow(DOMSH.SHADOWDOM_INIT);
		WEDLET.installSkins(tpl, sr, this.wedlet, this.localName);
		this.addEventListener("keydown", this.onKeyDown);
		this.addEventListener("dblclick", this.onDbClick);
		const langTypeProvSvc = tpl.getAttribute("langTypeProvSvc");
		if (langTypeProvSvc) this.langTypeProvider = wedMgr.reg.getSvc<ILangTypeProvider>(langTypeProvSvc);
		this.setLangTypeDef(tpl.getAttribute("langType"));
		const currentLangSvc = tpl.getAttribute("currentLangSvc");
		if (currentLangSvc) {
			const currentLang = wedMgr.reg.getSvc<ICurrentLang>(currentLangSvc);
			if (currentLang) currentLang(this, tpl);
			else console.warn(`loading wed: currentLangSvc '${currentLangSvc}' not found`);
		}
	}

	setLangTypeDef(langTypeDef: string | null) {
		if (this.langTypeDef === langTypeDef) return;
		if (!langTypeDef) {
			this.langTypeDef = null;
			this.langType = null;
		} else {
			this.langTypeDef = langTypeDef;
			this.langType = this.langTypeProvider ? this.langTypeProvider(langTypeDef) || defaultLangTypeProvider(langTypeDef) : defaultLangTypeProvider(langTypeDef);
			if (this.langType instanceof Promise) this.langType.then((ext) => {this.langType = ext});
		}
		if (this.cmView) {
			if (this.langType instanceof Promise) {
				const langTypeDef = this.langTypeDef;
				this.langType.then(ext => {
					if (langTypeDef !== this.langTypeDef) return; //race cond.
					this.cmView.dispatch({effects: langTypeConf.reconfigure(ext)});
				});
			} else {
				this.cmView.dispatch({effects: langTypeConf.reconfigure(this.langType || [])});
			}
		}
	}

	setDiffLangTypeDef(langTypeDef: string | null) {
		if (this.diffLangTypeDef === langTypeDef) return;
		if (!langTypeDef) {
			this.diffLangTypeDef = null;
			this.diffLangType = null;
		} else {
			this.diffLangTypeDef = langTypeDef;
			this.diffLangType = this.langTypeProvider ? this.langTypeProvider(langTypeDef) || defaultLangTypeProvider(langTypeDef) : defaultLangTypeProvider(langTypeDef);
			if (this.diffLangType instanceof Promise) this.diffLangType.then((ext) => {this.diffLangType = ext});
		}
	}

	setCmTheme(ext: Extension) {
		this.cmView?.dispatch({effects: themeConf.reconfigure(ext)});
		this.getDiffEditor()?.dispatch({effects: themeConf.reconfigure(ext)});
	}

	setEditMode(mode: EWedletEditMode): void {
		//console.log("setEditMode:::",mode, EWedletEditModeLabel[mode]);
		DOM.setAttr(this, "edit-mode", EWedletEditModeLabel[mode]);
		this.cmView?.dispatch({effects: readOnlyConf.reconfigure(EditorView.editable.of(mode === EWedletEditMode.write))});
	}

	refreshBindValue(val: string | null, children?: IJmlSubSet): void {
		if (this.batching) return;
		const state = EditorState.create({
			doc: val || Text.empty,
			extensions: this.addTheme(this.addLangType([
				lineNumbers(),
				//EditorView.lineWrapping,
				highlightSpecialChars(),
				//history(),
				foldGutter(),
				//drawSelection(),
				//EditorState.allowMultipleSelections.of(true),
				indentOnInput(),
				defaultHighlightStyle.fallback,
				bracketMatching(),
				closeBrackets(),
				autocompletion(),
				EditorState.tabSize.of(2),
				//highlightActiveLine(),
				//highlightSelectionMatches(),
				annotsField.extension,
				readOnlyConf.of(EditorView.editable.of(WEDLET.isWritableWedlet(this.wedlet))),
				keymap.of([
					...closeBracketsKeymap,
					...defaultKeymap,
					// ...searchKeymap,
					// ...historyKeymap,
					...foldKeymap,
					...commentKeymap,
					...completionKeymap,
					defaultTabBinding,
					// ...lintKeymap
				])
				//listenChanges
			]))
		});

		if (this.cmView) {
			this.cmView.setState(state);
		} else {
			this.cmView = new EditorView({
				state,
				parent: this.shadowRoot,
				root: this.shadowRoot,
				dispatch: this.cmDispatch.bind(this)
			});
			this.focusableElement = this.cmView.contentDOM;
		}
	}

	protected cmDispatch(tr: Transaction) {
		if (tr.docChanged) {
			this.batching = true;
			this.wedlet.wedMgr.freezeFocus = true;
			try {
				if (this.wedlet.isVirtual()) {
					WEDLET.insertDatasFromDisplay(this.wedlet as IVirtualisableWedlet, null, tr.newDoc.sliceString(0));
				} else {
					const batch = this.wedlet.wedMgr.docHolder.newBatch();
					//console.group("startBatch");
					tr.changes.iterChanges((fromA: number, toA: number, fromB: number, toB: number, inserted: Text) => {
						//console.log("Tr -> batch", fromA, toA, fromB, toB, inserted);
						if (inserted.length > 0) {
							batch.spliceSequence(XA.append(this.wedlet.wedAnchor, fromA), toA - fromA, inserted.sliceString(0))
						} else if (toA > fromA) {
							batch.deleteSequence(XA.append(this.wedlet.wedAnchor, fromA), toA - fromA);
						}
						batch.needAdjustForNextAdds();
					});
					//console.groupEnd();
					batch.doBatch();
				}
				this.cmView.update([tr]);
			} finally {
				this.batching = false;
				this.wedlet.wedMgr.freezeFocus = false;
			}
		} else {
			this.cmView.update([tr]);
		}
	}

	insertChars(from: number, chars: string, msg: IXmlMsg) {
		if (this.batching) return;
		//console.log("Batch ->tr : insert ", from, chars);
		this.cmView.update([this.cmView.state.update({
			changes: {from: from, insert: chars}
		})]);
	}

	deleteChars(from: number, len: number, msg: IXmlMsg) {
		if (this.batching) return;
		//console.log("Batch ->tr : deleteChars ", from, len);
		this.cmView.update([this.cmView.state.update({
			changes: {from: from, to: from + len}
		})]);
	}

	replaceChars(chars: string, msg: IXmlMsg) {
		if (this.batching) return;
		//console.log("Batch ->tr : replaceChars ", chars);
		this.cmView.update([this.cmView.state.update({
			changes: {from: 0, to: this.cmView.state.doc.length, insert: chars}
		})]);
	}

	isEmpty(): boolean {return this.cmView.state.doc.length === 0}

	protected redrawAnnotRequest = 0;

	drawAnnot(annot: ISkAnnot): boolean {
		if (annot instanceof SkSearchTextAnnot) { //  || (WEDLET.diffLib?.isDiffAnnot(annot) && annot.diffSession === this.wedlet.wedMgr.docHolder.getDiffSession())
			this.planRedrawAnnots();
		} else { // A suppr quand diff intégré.
			insertAnnot(this, annot);
		}
		return true;
	}

	eraseAnnot(annot: ISkAnnot): boolean {
		if (annot instanceof SkSearchTextAnnot) { // || WEDLET.diffLib?.isDiffAnnot(annot)
			this.planRedrawAnnots();
			return true;
		} else { // A suppr quand diff intégré.
			return removeAnnot(this, annot);
		}
	}

	planRedrawAnnots() {
		if (!this.redrawAnnotRequest) this.redrawAnnotRequest = window.requestIdleCallback(this._redrawAnnotExecutor || (this._redrawAnnotExecutor = this.redrawAnnotExecutor.bind(this)))
	}

	protected _redrawAnnotExecutor: (this: BoxInputCode) => void;

	redrawAnnotExecutor() {
		this.redrawAnnotRequest = 0;
		if (!this.isConnected) return;
		const wedMgr = this.wedlet.wedMgr;
		const newAnnots = wedMgr.docHolder.getAnnots(this.wedlet.wedAnchor);
		//const diffSess = wedMgr.docHolder.getDiffSession();
		const annotValues = [];
		for (let a of newAnnots) {
			if (isSkTextAnnot(a)) {
				const start = a.offsetStart;
				annotValues.push({from: start, to: start + a.len, type: searchMark});
			}
			// else if (WEDLET.diffLib?.isDiffAnnot(a) && a.diffSession === diffSess) {
			// 	console.log("annot:::",a);
			// }
		}
		this.cmView.dispatch({effects: annotsEffect.of(annotValues)});
	}

	focusSkAnnot(annot: ISkAnnot): boolean {
		if (isSkTextAnnot(annot)) {
			const start = annot.offsetStart;
			this.focusableElement.focus();
			this.cmView.dispatch({selection: {head: start, anchor: start + annot.len}, scrollIntoView: true});
			return true;
		}
		return false;
	}

	makeInputForDiff(annot: IDiffAnnotValue): HTMLElement {
		const state = EditorState.create({
			doc: annot.otherValue,
			extensions: this.addTheme(this.addDiffLangType([
				lineNumbers(),
				highlightSpecialChars(),
				foldGutter(),
				defaultHighlightStyle.fallback,
				EditorState.tabSize.of(2),
				EditorView.editable.of(false),
				keymap.of([
					...defaultKeymap,
					...foldKeymap,
				])
			]))
		});

		const cmView = new EditorView({
			state,
			root: this.shadowRoot
		});
		return cmView.dom;
	}

	onKeyDown(ev: KeyboardEvent) {
		if (ev.key === 'Tab' && (!ACTION.isAnyControlPressed(ev) || ev.shiftKey)) {
			//Insertion d'une tabulation
			ev.stopImmediatePropagation();
		} else if (ACTION.isAccelPressed(ev)) {
			if (ev.key === ' ') {
				ev.stopImmediatePropagation();
			}
		}
	}

	onDbClick(ev: MouseEvent) {ev.stopImmediatePropagation()}

	protected addLangType(exts: Extension[]): Extension[] {
		if (this.langType instanceof Promise) {
			const langTypeDef = this.langTypeDef;
			this.langType.then(ext => {
				if (langTypeDef !== this.langTypeDef) return; //race cond.
				this.cmView.dispatch({effects: langTypeConf.reconfigure(ext)});
			});
			exts.push(langTypeConf.of([]));
		} else if (this.langType != null) {
			exts.push(langTypeConf.of(this.langType));
		} else {
			exts.push(langTypeConf.of([]));
		}
		return exts;
	}

	protected addDiffLangType(exts: Extension[]): Extension[] {
		if (this.diffLangType instanceof Promise) {
			const langTypeDef = this.diffLangType;
			this.diffLangType.then(ext => {
				if (langTypeDef !== this.diffLangType) return; //race cond.
				this.getDiffEditor()?.dispatch({effects: langTypeConf.reconfigure(ext)});
			});
			exts.push(langTypeConf.of([]));
		} else if (this.diffLangType != null) {
			exts.push(langTypeConf.of(this.diffLangType));
		} else if (this.langType instanceof Promise) {
			const langTypeDef = this.diffLangType;
			this.langType.then(ext => {
				if (langTypeDef !== this.diffLangType) return; //race cond.
				this.getDiffEditor()?.dispatch({effects: langTypeConf.reconfigure(ext)});
			});
			exts.push(langTypeConf.of([]));
		} else {
			exts.push(langTypeConf.of(this.langType || []));
		}
		return exts;
	}

	getDiffEditor(): EditorView {
		const ed: ICmEditorTag | null = DOM.findFirstChild(this.shadowRoot, (n): n is WedDiffValue => n.localName === "wed-diff-value")?.firstElementChild as HTMLElement;
		return ed?.cmView.view;
	}

	protected addTheme(exts: Extension[]): Extension[] {
		exts.push(getCmTheme());
		return exts;
	}
}

AgEltBoxInsertDrawerBox(AgEltBoxSelection(BoxInputCode, {}));

REG.reg.registerSkin('box-input-code', 1, /* language=CSS */ `
	:host {
		display: flex;
		flex-direction: column;
	  border-bottom: 1px solid var(--border-color);
  }

  :host([aria-multiline='true']) {
	  border: 1px solid var(--border-color);
  }

  .cm-scroller {
	  overflow: auto;
	  font-family: var(--font-mono, 'monospace') !important;
	  font-size: .9em;
  }

  .cm-editor:not(.cm-focused) {
	  background-color: unset !important;
  }

  .cm-editor.cm-focused {
	  outline: var(--edit-caret-focus) !important;
	  background-color: var(--edit-bgcolor) !important;
  }

  .cm-gutters,
  .cm-foldPlaceholder {
	  background-color: unset !important;
	  color: var(--fade-color) !important;
	  border-color: var(--border-color) !important;
  }

  .cm-gutter {
	  user-select: none;
  }

  .cm-searchMatch {
	  background-color: var(--edit-search-bgcolor) !important;
		outline: none !important;
	}

	::selection {
		color: currentColor !important;
		background-color: var(--edit-seltext-bgcolor) !important;
	}

	::-webkit-scrollbar {
		width: .6em;
	}

	::-webkit-scrollbar-track {
		background-color: var(--scroll-color);
		filter: opacity(.1);
	}

	::-webkit-scrollbar-thumb {
		border-radius: .2em;
		box-shadow: inset 0 0 .3em var(--scroll-thumb-color);
	}
`);
/* pour extension drawSelection() : couteuse et intérêt douteux.
	.cm-cursor {
		border-color: var(--color) !important;
	}

	.cm-selectionBackground {
		background-color: var(--edit-seltext-bgcolor) !important;
	}

	:not(.cm-focused) > * > * > .cm-selectionBackground {
		background-color: transparent !important;
	}
 */
window.customElements.define("box-input-code", BoxInputCode);

interface ICmEditorTag extends HTMLElement {
	cmView?: { view: EditorView }
}

function getCurrentSel(wedMgr: WedMgr): IXAddrRangeSel | undefined {
	const focus = wedMgr.lastFocus;
	if ((focus as ICmEditorTag)?.cmView) {
		const boxCodeEdit = DOMSH.findHost<BoxInputCode>(focus);
		if (boxCodeEdit) {
			const rg = (focus as ICmEditorTag).cmView.view.state.selection.main;
			const xa = boxCodeEdit.wedlet.wedAnchor;
			return {start: XA.freeze(XA.append(xa, rg.from)), end: XA.freeze(XA.setAtDepth(xa, -1, rg.to)), startInText: true, endInText: true}
		}
	}
	return undefined;
}

function hookMsgForNextSel(wedMgr: WedMgr, transac: Msg, msg: Msg): void | true {
	if (!msg) return;
	//console.log("hookMsgForNextSel:::", transac, msg);
	if (wedMgr.docHolderAsync.isMsgFromUs(transac)) {
		//On est à l'origine de ce msg, on prend le Focus.
		if (msg instanceof XmlBatch && msg.selAfter) {
			//batch avec selAfter renseigné.
			const wedlet = WEDLET.findWedlet(wedMgr.rootWedlet, msg.selAfter.addr, {lastAncestorIfNone: true});
			if (wedlet?.model instanceof BoxModelCm) {
				const input = wedlet.model.findBoxInputCode(wedlet as BoxWedlet);
				if (input?.cmView) {
					input.focusableElement.focus();
					//console.log("input.focusableElement:::",input.focusableElement);
					const anchor = XA.last(msg.selAfter.end || msg.selAfter.addr) as number || 0;
					const head = msg.selAfter.end ? XA.last(msg.selAfter.addr) as number || 0 : undefined;
					input.cmView.dispatch({selection: {anchor, head}})
					return true;
				}
			}
		} else if (isXmlMsg(msg)) {
			const wedlet = WEDLET.findWedlet(wedMgr.rootWedlet, msg.xa, {lastAncestorIfNone: true});
			if (wedlet?.model instanceof BoxModelCm) {
				const input = wedlet.model.findBoxInputCode(wedlet as BoxWedlet);
				if (input?.cmView) {
					input.focusableElement.focus();
					//console.log("input.focusableElement:::", input.focusableElement);
					const start = XA.last(msg.xa) as number;
					if (msg instanceof XmlInsertMsg) {
						input.cmView.dispatch({selection: {anchor: start + msg.len, head: start}});
					} else {
						input.cmView.dispatch({selection: {anchor: start}});
					}
					return true;
				}
			}
		}
	}
}

const themeConf = new Compartment();
const darkTheme: Extension = oneDark;
const ligthTheme: Extension = [];

let themeIsDark: boolean;

export function getCmTheme(): Extension {
	if (themeIsDark === undefined) {
		//1er init
		if (desk && UiThemeDeskFeat.isIn(desk)) {
			themeIsDark = desk.currentTheme ? desk.currentTheme.isDark : window.matchMedia("(prefers-color-scheme: dark)").matches;
			desk.onThemeChange.add((theme: ThemeAction) => {
					const newState = theme?.isDark || false;
					if (newState !== themeIsDark) {
						themeIsDark = newState;
						const newExt = themeIsDark ? darkTheme : ligthTheme;
						DOMSH.findFlatNext(document.body, document.body, (n): n is Node => {
							if (n instanceof BoxInputCode) n.setCmTheme(newExt);
							return false;
						})
					}
				}
			)
		} else {
			themeIsDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
		}
	}
	return themeConf.of(themeIsDark ? darkTheme : ligthTheme);
}


const searchMark = Decoration.mark({class: "cm-searchMatch"}) as Decoration & RangeValue;
const annotsEffect = StateEffect.define<{ from: number, to: number, type: Decoration & RangeValue }[]>()
const annotsField = StateField.define<DecorationSet>({
	create() {
		//return Decoration.none
		return RangeSet.empty;
	},
	update(marks, tr) {
		for (let e of tr.effects) if (e.is(annotsEffect)) {
			//return RangeSet.of(e.value.map(annot => annot.type.range(annot.from, annot.to)));
			const rgBd = new RangeSetBuilder<Decoration & RangeValue>();
			for (let annot of e.value) {
				rgBd.add(annot.from, annot.to, annot.type);
			}
			return rgBd.finish();
		}
		return marks.map(tr.changes);
	},
	provide: f => EditorView.decorations.from(f)
})

/** Compartment de config de l'état readOnly/writable du widget. */
const readOnlyConf = new Compartment();

/**
 * Fonction pour définir la langue courrante dynamiquement.
 * Cette fonction est appelée à l'initialisation du widget.
 * Elle doit appeler widget.setLangTypeDef(...) pour affecter la langue courante.
 */
export type ICurrentLang = (widget: BoxInputCode, tpl: Element) => void


/** Founisseur de langages. */
export type ILangTypeProvider = (def: string) => LanguageSupport | Promise<LanguageSupport> | null

/** Compartment de config de la langue courante. */
const langTypeConf = new Compartment();

/** Map des langages par défaut chargés ou en chargement. */
const langTypeMap = new Map<string, LanguageSupport | Promise<LanguageSupport> | null>();

function fetchLang<LIB>(def: string, lib: Promise<LIB>, fun: keyof LIB, params?: any): Promise<LanguageSupport> {
	const promise = lib.then((l) => {
		const ext = (l[fun] as any as Function)(params);
		langTypeMap.set(def, ext);
		return ext;
	})
	langTypeMap.set(def, promise);
	return promise;
}

function fetchLangDyn<LIB>(def: string, lib: Promise<LIB>, build: (lib: LIB) => LanguageSupport): Promise<LanguageSupport> {
	const promise = lib.then((l) => {
		const ext = build(l);
		langTypeMap.set(def, ext);
		return ext;
	})
	langTypeMap.set(def, promise);
	return promise;
}

function fetchLegacyLang<LIB>(def: string, lib: Promise<LIB>, key: keyof LIB): Promise<LanguageSupport> {
	const promise = lib.then((l) => {
		const streamParser = l[key] as any as StreamParser<any>;
		const ext = new LanguageSupport(StreamLanguage.define(streamParser) as any as Language);
		langTypeMap.set(def, ext);
		return ext;
	})
	langTypeMap.set(def, promise);
	return promise;
}


/** Fournisseur par défaut des langages. */
export function defaultLangTypeProvider(def: string): LanguageSupport | Promise<LanguageSupport> | null {
	const idx = def?.indexOf(':');
	let params: any;
	if (idx > 0) {
		def = def.substring(0, idx);
		params = JSON.parse(def.substring(idx + 1));
	}
	let langType = langTypeMap.get(def);
	if (langType !== undefined) return langType;
	switch (def) {
	case "text/css":
		return fetchLang(def, import("res/codemirror/lang-css.js"), "css");
	case "text/x-csrc":
	case "text/x-c++src":
		return fetchLang(def, import("res/codemirror/lang-cpp.js"), "cpp");
	case "text/html":
		return fetchLang(def, import("res/codemirror/lang-html.js"), "html");
	case "text/x-java":
		return fetchLang(def, import("res/codemirror/lang-java.js"), "java");
	case "text/javascript":
		return fetchLang(def, import("res/codemirror/lang-javascript.js"), "javascript", {jsx: false, typescript: false});
	case "text/typescript":
		return fetchLang(def, import("res/codemirror/lang-javascript.js"), "javascript", {jsx: false, typescript: true});
	case "text/jsx":
		return fetchLang(def, import("res/codemirror/lang-javascript.js"), "javascript", {jsx: true, typescript: false});
	case "text/tsx":
		return fetchLang(def, import("res/codemirror/lang-javascript.js"), "javascript", {jsx: true, typescript: true});
	case "application/json":
	case "application/ld+json":
		return fetchLang(def, import("res/codemirror/lang-json.js"), "json");
	case "text/x-markdown":
		buildDefaultLangDesc();
		return fetchLang(def, import("res/codemirror/lang-markdown.js"), "markdown", Object.assign({codeLanguages: LANG_DESCS}, params));
	case "text/x-python":
	case "text/x-cython":
		return fetchLang(def, import("res/codemirror/lang-python.js"), "python", params);
	case "text/x-rustsrc":
		return fetchLang(def, import("res/codemirror/lang-rust.js"), "rust", params);
	case "text/x-sql":
		return fetchLang(def, import("res/codemirror/lang-sql.js"), "sql", params);
	case "text/x-mysql":
		return fetchLangDyn(def, import("res/codemirror/lang-sql.js"), lib => lib.sql(Object.assign({dialect: lib.MySQL}, params)));
	case "text/x-mariadb":
		return fetchLangDyn(def, import("res/codemirror/lang-sql.js"), lib => lib.sql(Object.assign({dialect: lib.MariaSQL}, params)));
	case "text/x-mssql":
		return fetchLangDyn(def, import("res/codemirror/lang-sql.js"), lib => lib.sql(Object.assign({dialect: lib.MSSQL}, params)));
	case "text/x-pgsql":
		return fetchLangDyn(def, import("res/codemirror/lang-sql.js"), lib => lib.sql(Object.assign({dialect: lib.PostgreSQL}, params)));
	case "text/x-plsql":
		return fetchLangDyn(def, import("res/codemirror/lang-sql.js"), lib => lib.sql(Object.assign({dialect: lib.PLSQL}, params)));
	case "application/xml":
		return fetchLang(def, import("res/codemirror/lang-xml.js"), "xml", params);

		//********** legacy *****
	case "text/x-diff":
		return fetchLegacyLang(def, import("res/codemirror/legacy-modes/diff.js"), "diff");
	case "text/x-dockerfile":
		return fetchLegacyLang(def, import("res/codemirror/legacy-modes/dockerfile.js"), "dockerFile");
	case "application/xml-dtd":
		return fetchLegacyLang(def, import("res/codemirror/legacy-modes/dtd.js"), "dtd");
	case "text/x-mathematica":
		return fetchLegacyLang(def, import("res/codemirror/legacy-modes/mathematica.js"), "mathematica");
	case "text/x-nginx-conf":
		return fetchLegacyLang(def, import("res/codemirror/legacy-modes/nginx.js"), "nginx");
	case "text/x-octave":
		return fetchLegacyLang(def, import("res/codemirror/legacy-modes/octave.js"), "octave");
	case "text/x-perl":
		return fetchLegacyLang(def, import("res/codemirror/legacy-modes/perl.js"), "perl");
		// case "text/x-php":
		// case "application/x-httpd-php":
		// 	return fetchLegacyLang(def, import("res/codemirror/legacy-modes/php.js"), "php");
	case "application/x-powershell":
		return fetchLegacyLang(def, import("res/codemirror/legacy-modes/powershell.js"), "powerShell");
	case "text/x-properties":
	case "text/x-ini":
		return fetchLegacyLang(def, import("res/codemirror/legacy-modes/properties.js"), "properties");
	case "text/x-rsrc":
		return fetchLegacyLang(def, import("res/codemirror/legacy-modes/r.js"), "r");
	case "text/x-ruby":
		return fetchLegacyLang(def, import("res/codemirror/legacy-modes/ruby.js"), "ruby");
	case "text/x-sh":
		return fetchLegacyLang(def, import("res/codemirror/legacy-modes/shell.js"), "shell");
	case "text/x-stex":
		return fetchLegacyLang(def, import("res/codemirror/legacy-modes/stex.js"), "stex");
	case "text/x-swift":
		return fetchLegacyLang(def, import("res/codemirror/legacy-modes/swift.js"), "swift");
	case "text/x-vb":
		return fetchLegacyLang(def, import("res/codemirror/legacy-modes/vb.js"), "vb");
	case "text/x-yaml":
		return fetchLegacyLang(def, import("res/codemirror/legacy-modes/yaml.js"), "yaml");
	case "text/x-csharp":
		return fetchLegacyLang(def, import("res/codemirror/legacy-modes/clike.js"), "csharp");
	case "text/x-objectivec":
		return fetchLegacyLang(def, import("res/codemirror/legacy-modes/clike.js"), "objectiveC");
	case "text/x-scala":
		return fetchLegacyLang(def, import("res/codemirror/legacy-modes/clike.js"), "scala");
	case "x-shader/x-vertex":
	case "x-shader/x-fragment":
		return fetchLegacyLang(def, import("res/codemirror/legacy-modes/clike.js"), "shader");
	case "text/x-squirrel":
		return fetchLegacyLang(def, import("res/codemirror/legacy-modes/clike.js"), "squirrel");
	case "text/x-ceylon":
		return fetchLegacyLang(def, import("res/codemirror/legacy-modes/clike.js"), "ceylon");
	case "text/x-kotlin":
		return fetchLegacyLang(def, import("res/codemirror/legacy-modes/clike.js"), "kotlin");
	case "text/x-nesc":
		return fetchLegacyLang(def, import("res/codemirror/legacy-modes/clike.js"), "nesC");
	case "text/x-cmake":
		return fetchLegacyLang(def, import("res/codemirror/legacy-modes/cmake.js"), "cmake");
	default: //text/plain ou inconnu
		return null;
	}
}

/**
 * Listes des langages connus pour injection auto (markdown...)
 * Attention, si ce tableau est complété par des appels externes, appeler avant buildDefaultLangDesc()
 * pour bénéficier des langages par défaut.
 */
export const LANG_DESCS: LanguageDescription[] = [];

export function buildDefaultLangDesc() {
	if (LANG_DESCS.length > 0) return;

	function def(name: string, mime: string) {
		return {name, load: async () => defaultLangTypeProvider(mime)}
	}

	LANG_DESCS.push(
		LanguageDescription.of(def("css", "text/css")),
		LanguageDescription.of(def("html", "text/html")),
		LanguageDescription.of(def("java", "text/x-java")),
		LanguageDescription.of(def("xml", "application/xml"))
		//TODO add...
	);
}